import { getFirAuth } from '../Api/firebase'

export const getFirUserAndStatus = async () => {
  const user = (await getFirAuth())?.currentUser
  const isAnonymous = user?.isAnonymous
  return { user, isAnonymous }
}
